<script setup>
import ClickableCell from '@/components/lists/ClickableCell';
import {computed} from 'vue';
import {tournamentCardLine} from '~/utils/competitionCard';
// Props
const props = defineProps({
  tournament: {
    type: Object,
    default: () => null
  }
});
// X213: "Tournament · Tennis · 10 players"; nobody yet = "Open to join" when it has a link
const subtitle = computed(() => tournamentCardLine(props.tournament));
</script>

<template>
  <clickable-cell
      icon="mdi-trophy"
      tone="tournament"
      class="mb-3"
      :to="{ name: 'TournamentDetail', params: { tournamentId: props.tournament.id } }"
      :title="tournament.name"
      :subtitle="subtitle"
      subtitle-one-line
  />
</template>
